<template>
    <section>
        <Nav/>
        <VMenu/>
        <div class="mainSection">
            <router-view></router-view>     
        </div> 
    </section>
</template>
<script>
import Nav from './Nav'
import VMenu from './VMenu'
export default({
    name:'Home',
    components:{
        Nav,
        VMenu,
    },
})
</script>
<style>
 .mainSection {
   position: relative;
 }
 
</style>
